<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 951.87 326.4"
    id="auto-calc"
    class="calculator__svg"
  >
    <image
      overflow="visible"
      width="100.3%"
      height="100%"
      xlink:href="/public/images/pages/kuzov/car.jpg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    ></image>
    <g
      id="крыша"
      data-name="Крыша"
    >
      <path
        class="cls-1"
        d="M162.63,389.67s26.81-.54,34.06-.42,33.75,1.19,35.63,1.38,15,1.44,19.66,2,24.87,3.81,26,4,11.89,2.71,13.77,3.46a18.71,18.71,0,0,0,4.14,1l.31-1s-5.56-1.69-10.06-2.94-22.75-5-24.19-5.31-17.69-2.94-22.62-3.5-18.87-1.94-25.81-2.31S193.25,385,184.5,385H161.63s-8.81.31-9.94.31-3.19.25-3.19.25,6.69,0,8.63.56a13.56,13.56,0,0,1,3.87,1.7A6.58,6.58,0,0,1,162.63,389.67Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Крыло_заднее_правое"
      data-name="Крыло заднее"
    >
      <path
        class="cls-2"
        d="M88.75,416.5l-1-.75s-3.21,3-3.37,3.38-5.58,6-6,6.5-5.83,7.63-5.83,7.63-2.58,3.17-3.29,3.88-2.87,3.42-4.08,4.54-4.62,4.63-5.87,5.54-4,3.17-5,3.58S51,452,50.21,452.46a4.57,4.57,0,0,0-2,1.83,34.71,34.71,0,0,0-2.42,4.63c-.46,1.25-1.46,5.83-1.46,5.83s-.92,6-1.17,8-.67,7.13-.67,7.13l-.12,2.29.41.25.4.36,1.21.51,1.83.59.62-1.94a7.27,7.27,0,0,1,1-2c.79-1.23.67-1.44,1.33-2.1a9.91,9.91,0,0,1,1.69-1.52,3.72,3.72,0,0,1,1.69-.85,5.13,5.13,0,0,1,1.63-.08,4.51,4.51,0,0,1,2.65,1.65A14,14,0,0,1,59.69,481c.88,1.94,2.63,6.44,2.63,6.44l2.25,7.81,2.25,9.19L68,509.88l1.81.5,2.2.5-3-10.74-2.5-9.61-2.05-8.4-.76-5.38L63.33,474v-7.19l1-6.48L66,454l3.63-6.37,2.07-1.21,3.57-2.33,2.16-1.63.68-1.81a1.52,1.52,0,0,1-.77-.29,9.84,9.84,0,0,1-1.94-2.18,5.63,5.63,0,0,1-.94-2.41c.1-.48.4-1.42.4-1.42s1.31-2.9,1.75-3.5S78,428,78.83,426.94s5.63-6.33,5.63-6.33Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Капот"
      data-name="Капот"
    >
      <path
        class="cls-3"
        d="M183.75,426.33l-1.25,2v.58a19.22,19.22,0,0,0,.33,3.92l1.58,3.92a17.64,17.64,0,0,0,1.75,1.25c.83.5,6.33,0,6.33,0s7.5.36,9.67.22,10,.69,10,.69l12.58,1.58,13.75,1.83s8.5,1.75,9.25,2,8.33,3.08,8.33,3.08l5.25,3.5,3.08,2.83,1.08,2,6.75.43,20.08,1.66,16.17,1.83h3.42l4.35-1.59,6.66-1.78,7.07-1.49,8-1.1,9.34-1.19,5.91-.71,9.26-.73,15-.5,19.5,0h14.33l22.85,1.53,18.4,1.4,14.4,1.91,9,2.07,5.92,2.48,3.1,2.81,1.55,1.76-1.47-2.56S484,460.5,483,459.56a42.4,42.4,0,0,0-5-4.34,62.27,62.27,0,0,0-6.69-3.78c-1.28-.47-7.59-3.25-9.16-3.72s-9.47-2.78-10.81-3.06-11.78-2.56-14-2.91-10.16-1.78-13.69-2.16-11.69-1.56-14.75-2-13.25-1.59-14.87-1.72-14.75-1.62-17.94-1.87-18.37-1.69-18.94-1.75-5-.44-5-.44l-4.94-.31L335,431l-11.28-.44L309.44,430,297,429.48l-17.72-.77L256.49,428l-17.18-.48-15.74-.45-16.38-.15-12.88,0-8.25-.53Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Крыло_переднее_правое"
      data-name="Крыло переднее"
    >
      <path
        class="cls-4"
        d="M264.69,454.25l-3.35-3.33-5.25-3.5-6.95-2.58-8.54-2.07-10.51-1.56-10.35-1.34-9-1.1-10.92-.53s-12.17,0-12.5,0a10.47,10.47,0,0,1-1.17-.2l-1.37-1-1-1.94-1.11-3.28-.14-2.91,1.25-2.58s-2.42-.83-3.42-1.08-2.08-1.42-2.75-1.92-1.42-2.67-1.83-2.75-2.08,1.17-2.42,1.58-2.33,2-3,2.75-2.4,2.92-2.4,2.92l.25,2.7-.25,2.7-.37.73-1.12,1.63-1.4,1.5-1.71,1.5L160.92,441l-1.9,4.46-3.09,8-1.58,7.24-.59,8-.46,10.12.32,5.94.67,8.2,1,10.16.85,9.19.37,7.05-.41,7.46-1,1.75-.68,1.67.8.87,2,.55,1.58,8.83,2.54.54v-8.67l.67-5,.58-3.08,1.33-6.17s2.17-6.83,2.42-7.23,2.58-5.85,2.58-5.85l3.08-5.42,3.17-4.33.42-2.58s1.33-4.08,2-5.58,2.67-5.67,2.67-5.67,2.57-4.25,3.58-5.56a22.79,22.79,0,0,1,6.25-5.4,16.59,16.59,0,0,1,5-2.46,19,19,0,0,1,10.5,1.09c2.76,1.65,6.57,4.07,6.57,4.07l2.92-3.75,1.64-1.28,2-1.41,4.38-2.56,6-3.6,5.19-2.64,1.76-.85,3.09-.78,10.94-.1,11.75,0,3.67-.43Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="_Бампер_задний"
      data-name="Задний бампер"
    >
      <path
        class="cls-3"
        d="M46.23,483.84h0l-.85-.27a10.53,10.53,0,0,1-2.31-.94,2,2,0,0,0-.69-.5l-.31,3.5V496l-.62,1.44a5.75,5.75,0,0,0-.25,1,21.88,21.88,0,0,0,.44,3c.06.56,0,4.87,0,4.87l-.08,4.27a3.34,3.34,0,0,0,.33,1.63c.38.54,2.22,4.33,2.22,4.33l1.49,2.71.38.5,0-9.12s-.66-.36-.75-.58c-.44-1-.75-8.5-.71-14s.33-7.46.92-9.37S46.23,483.84,46.23,483.84Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Дверь_передняя_правая"
      data-name="Дверь передняя"
    >
      <g class="cls-5">
        <path
          class="cls-6"
          d="M117.46,417.41a16.3,16.3,0,0,0-1.83,4.23c.13-.34.25-.64.37-.9C116.39,419.89,116.9,418.72,117.46,417.41Z"
          transform="translate(-22.72 -336.94)"
        ></path>
        <path
          class="cls-6"
          d="M164.63,418.88c-.87-3.06-5.56-14.94-6.56-17.56a31.75,31.75,0,0,0-4.25-6.87c-1.19-1.62-4.25-2.75-5.94-3.25a20,20,0,0,0-6.94-.81c-1.81.31-8.87,1.25-9.94,1.63l-2.12.75s-6,12.35-6.94,14.23c-.67,1.41-2.8,6.52-4.48,10.43l.21-.37a5.78,5.78,0,0,1,3.07-2,10.07,10.07,0,0,0,2.34-1c0-.41,4.91-11,5.78-13.34a52.72,52.72,0,0,1,2.94-5.87,7.19,7.19,0,0,1,1.31-.81,57.36,57.36,0,0,1,10.44-1.19,15.15,15.15,0,0,1,7.37,2.56c1.69,1.06,3,4.25,4.62,6.56s4.25,11.06,5.69,13.94,4.94,16.06,4.94,16.06l-16.85,1s4.61,2.67,3.48,3.67a20.94,20.94,0,0,1-5.06,3.31c-.48.24-2.49,1.39-3.94.5-.43-.27-5.69-6.56-5.69-6.56-9.37.44-20.94,1.31-20.94,1.31,0-1.25,1.55-5,.56-5.87-2.27-1.91-2.88-4.54-2.12-7.54-1.59,4.17-4,13.88-4,13.88l-1.49.83-.48,2.27s-3.55,3.06-4.71,3.91l-1.16.84-3.37,5.75-1.88,6.28-1,3.14-.3,6.27s-.22,8-.23,10.62c0,3.63,1.42,13.19,1.42,13.19l2,17.38-1.68,10.38h-.2l-1,1.14-.86,1-.16.18v.92l3,.92,2.33,9.17,18,3.46,16.29,3.08,17.38,3.29,5.17,1-1-5.58-.54-3.25-2.58-.71-.21-.71,1-2.54.63-.87c.21-.08.46-7.29.42-9.33s-1.12-13.25-1.12-13.25-1.67-16.75-1.67-18-.62-6.29-.42-7.46.42-15.12,1.25-19.42,2-8.5,2.67-9.62,3.17-8.12,3.71-8.79,1.88-1.79,2.42-2.37,3.92-4.5,3.92-4.5a9,9,0,0,0,.69-3.83C167.94,427.75,165.5,421.94,164.63,418.88Z"
          transform="translate(-22.72 -336.94)"
        ></path>
      </g>
    </g>
    <g
      id="Стекло_двери_передней_правой"
      data-name="Стекло передней двери"
    >
      <g class="cls-7">
        <path
          class="cls-6"
          d="M161.25,415.81c-1.44-2.87-4.06-11.62-5.69-13.94s-2.94-5.5-4.62-6.56a15.15,15.15,0,0,0-7.37-2.56,57.36,57.36,0,0,0-10.44,1.19,7.19,7.19,0,0,0-1.31.81,52.72,52.72,0,0,0-2.94,5.88c-.87,2.31-5.75,12.92-5.78,13.34s1-.79,3.68-1.1,9.78-1.38,9.78-1.38l8.77-.15a2.72,2.72,0,0,1,1.74.38,9.21,9.21,0,0,1,3.51,2.73,9.38,9.38,0,0,1,2.16,3.86,23.73,23.73,0,0,1-.38,5.82,29.35,29.35,0,0,1-2,5.18,5.7,5.7,0,0,1-2.52,2.28c-1,.23,1.5,1.25,1.5,1.25l16.85-1S162.69,418.69,161.25,415.81Z"
          transform="translate(-22.72 -336.94)"
        ></path>
        <path
          class="cls-6"
          d="M122.44,432a39.73,39.73,0,0,1-4-2.07l-1.24,5.18,20.62-1.44L136.5,432S123.28,432.19,122.44,432Z"
          transform="translate(-22.72 -336.94)"
        ></path>
      </g>
    </g>
    <g
      id="Дверь_задняя_правая"
      data-name="Дверь задняя"
    >
      <path
        class="cls-8"
        d="M122,395s-8.46,3.83-9,4.21-7.08,3.88-8.71,5l-5.77,4-1.24,2.4,3.38-2a51.77,51.77,0,0,0,4.76-3.47c.17-.4,11.7-6.13,11.7-6.13a15,15,0,0,0,3.35-1.38c1.24-.64,3.52-1.56,5.27-2.23-.59.93-4.77,7.58-6,10.19-1.31,2.81-4.31,9.75-5.94,13.69s-4.44,13.19-4.75,13.94a20.37,20.37,0,0,0-.68,2.49l-2.59.26-19.23,2.2s2.85-9.92,6.22-15.79c2.13-3.7,9.06-14.47,9.06-14.47l-4.56,2.69s-7.27,10.84-9.34,14.63c-2.49,4.55-7.15,13.38-7.15,13.38l-1.5,1.25-1.12,1.5-.87,1.38-4.62,3.13-3,1.75L66,454l-1.5,5.5-1.12,7.75V474l1,7.63,1.88,7.75,4.13,15.88L71.76,510l.25.84.74,2.83,1.33,3.38v.17c.58,1.58,2.58,6.17,2.58,6.17a2.58,2.58,0,0,0,1.75,1.67c1.42.42,8.08,1.71,8.08,1.71L101.67,530l-2.08-9.5-3-.92v-.92l2-2.29,1.25-5.75.63-4.62-.63-4.62s-1.75-12.87-1.37-12.75-1.37-10.12-1.37-10.12L97,470.13l.38-6.37.5-5.12,1.25-5.37,1.38-4.12,1.88-3.12,1.5-2.62,4.13-3,1.75-1.75.48-2.27,1.49-.83h0l.28-.15-.25,0,.25-1.15c.28-1.28,4.46-14.1,4.46-14.1s3.26-8,4.13-10.15,5.19-10.56,5.19-10.56l2.27-4.89.88-1.8Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Стекло_двери_задней_правой"
      data-name="Стекло задней двери"
    >
      <path
        class="cls-3"
        d="M101.76,407.94s-6.94,10.77-9.06,14.47c-3.3,5.75-6.1,15.37-6.22,15.77l11-1.24,8.19-.94,1.11-.11,1.32-.15.5-1.4a9.59,9.59,0,0,1,.35-1.09c.31-.75,3.13-10,4.75-13.94.57-1.37,1.3-3.12,2.07-4.92l1.07-2.49.68-1.56c.84-1.91,1.6-3.63,2.11-4.72.91-1.94,3.45-6.12,4.94-8.52l1-1.79s-2.23,1.19-3.19,1.56-5.42,2.13-6.92,2.88-6.25,3.42-7.87,4.29S101.76,407.94,101.76,407.94Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Фара_правая"
      data-name="Фара передняя"
    >
      <path
        class="cls-3"
        d="M236.08,457.5c-.32,1.25,2.17,4.5,2.17,4.5s7.5,9.92,9.92,12a26.59,26.59,0,0,0,9.83,5.67c4.08,1.17,17.33,2.08,17.33,2.08l31.33,2.08s14.91,1.34,19.83.75a75.77,75.77,0,0,0,8.83-2.5s8-2.63,9.25-4.92c.5-.9-.15-3.72-.42-4.08-1.25-1.67-9.17-6.67-14.08-8.42s-13.83-3.83-16.5-3.83-12.83-2-17.25-2.25-24.73-2-33-2.33c-5.6-.19-21,.07-22.42,0S236.33,456.52,236.08,457.5Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Фара_левая"
      data-name="Фара передняя"
    >
      <path
        class="cls-9"
        d="M486.56,464.5l2.35,4.5s2.75,6,3.25,7,1.83,6.17,1.83,6.17l.77,2.65-1.44.94-2.67.79-1.79.21-1.12-1-1.33-9.34-1-9.34.44-1.69.34-.4.41-.48"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Лобовое_стекло"
      data-name="Стекло лобовое"
    >
      <path
        class="cls-3"
        d="M164.42,391.58s9.67,17.33,11.17,20.5,5.92,12.17,8.33,13.25,11.17,1.58,11.17,1.58H218.5l26.17.75,29.92.83,16.75.75,36.58,1.5,19.83.75s-11.58-7.67-14.42-9.42-23.08-13.83-26.17-15.33-15.75-7.08-19.58-8.08-14.42-2.92-18.92-3.67a283,283,0,0,0-29-3.42c-10.75-.5-30.17-1.92-35.67-1.92S164.42,391.58,164.42,391.58Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Бампер_передний"
      data-name="Передний бампер"
    >
      <path
        class="cls-4"
        d="M495.54,489.79l-.77-3.92v-1.06l-1.44.94-2.21.69a10.25,10.25,0,0,1-2.25.31,6.47,6.47,0,0,1-1.12-1s-1.06-6-1.06-6.62-1.31-12.06-1.31-12.06a4.73,4.73,0,0,1,.44-1.69c.31-.37.75-.87.75-.87l-2.25-2.56a13.25,13.25,0,0,0-3.12-2.44,46.36,46.36,0,0,0-9.06-3.12c-2.62-.5-11.06-2.19-13.12-2.31s-14.62-1.44-16.06-1.44-19.81-1.37-21.87-1.37-17.62-.71-17.62-.71l-24.8,0-.06,0-1.08,0h0L363,451l-7.21.46-6.08.71-7.29.92-9,1.17-5,.75-5.83,1.33-4.83,1.29-4.37,1.21L313,460l9.13,2.37,11.41,3.8,10.15,6.4,1.08,2.8-.18,1.79-5.95,3.68-8.91,3-3.81.9-15.4-.59-18.69-1.3-14.75-1-12.33-1.09-6.09-.94-4.39-1.64-3.35-2-4.87-4.38-6.35-7.88-4.37-6.24-1.92.5s-6.5,3.58-7.58,4.33-6.75,4-7.58,4.5-2.42,1.92-3.17,2.42a26,26,0,0,0-2.92,3.75s7.77,6.52,11.27,14.15a229.06,229.06,0,0,1,9.87,27.62c1.88,6.94,4.62,23.81,4.62,23.81l2.69,15.69.9,4.68s-.73.45-.71.94c.08,1.66,1.44,3.19,1.93,5.44.14.66.51,2.66.51,2.66l8.5,1.5,17.75,1s5.58.5,6,.5h71.58s6.17-.67,7.1-.67a2.18,2.18,0,0,0,1.56-.83s1.75-.83,2.08-1.08a9.52,9.52,0,0,1,2.67,0c.25,0,5.83-.33,5.83-.33l16.58-.75,16.25-1,14.92-.92,10.08-.83s14.33-1.33,14.75-1.33,18.75-1.58,18.75-1.58,16.83-1.75,17.08-1.75l4.75-.08,11.33.42,2-1.33L495,556.5v-1l-1-1.92-.33-.83.67-1.25.67-1.58v-2.26l-.83-1.41-1.33-2.42-.41-2.08-.12-6.56,1.31-.75,2.25-1.31-.11-2.05a31.65,31.65,0,0,1-3.64,1.49,6.61,6.61,0,0,1-1.94.5s-1.87-1.31-2.25-1.69-2.69-2.25-3.69-3.31l-4.19-4.44-.75-1.87v-1.19l1.38-.69,1.69-.5,2.75-1.44.94-1.19,1.69-3,1.13-1.69,2.38-1.94,1.94-2,.44-.75h.44l-.06.38-.37,1.13-.25,6.5h.31l.25,1.31-.94,1.25-.81,6.19,1.15.54.75-4.83.83-7.17.58-6.17.42-3.08v-1.33l.29-2.75v-5.17ZM263,537.56c0-.62,4.38-4.25,4.38-4.25l5.5-12.75,3.81-6.5,3.5-2.31,5.87-.56c1.25-.12,6.62.75,8.25.81s11.81,1.19,13.31,1.31,12.19,1.81,14.06,1.94a56.4,56.4,0,0,1,6.5,1.31l2.81,1.13,8.63,4.62,1.94,1,16.5.69h1.5l.38.63-1.31,1.44-2.75,2.44L351,532.38l-4.44,3.25L343,538.19l-2.06,1-2.44,1H325.88l-20.94-.37-25.37-.81L263,538.19Zm218.33-2.64,1.72,1.76,2.33.16,5-.87.86-.31L488.83,543l-4.26,1.8-4.15.74-11.67.82-22,1.42-24.92,1.48-23.25,1.32-26,1.38-16.09.82-19.42.32-28.58.48L289.07,553l-11.65-.71-1.93-.36-3.27-1.52-2.37-2.32-3.18-5.4,1.63-.49,7.29.11,40.67,1.33,17.75,0,15,0,4.93-1.74,8.34-4,6.42-1.3,2.31-.32,16.45-.81,17.38-.9,25.19-1,16.37-.69,20.31-.83,9.19-.24,3,.91Zm3.35-59.61v8.12l-1,8.67-1.15,5.72-.9,1.64L479,502.31l-4.38,1.84-7.18,2.79-6.17,1.18-14.64,1-16.75.42H411.06L396.32,509l-7.25-.41-5.68-1.06-12.31-3.36L362.88,501,360,498.13l-1.66-5.23-1.27-8.65-.55-9.66V468l1.11-2.75,2.56-1.9,5.23-1.12,15.5-.54,16.15-.21,21.31-.14,18,.52,15.5.69,15.5.89,9.69,1.07,3.35.7,2.37,1.46,1.25,1.75.65,2.52Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Зеркало_правое"
      data-name="Зеркало"
    >
      <path
        class="cls-3"
        d="M143.75,440.5l-5.5-6.33L136.5,432h-5.17a86.78,86.78,0,0,1-8.89,0,7.63,7.63,0,0,1-2-.78,14.17,14.17,0,0,1-1.67-1c-1-.78-3.42-3.58-3.42-3.58s-.67-.77-.68-1.08c0-1.56,1.34-4.75,1.34-4.75a22.8,22.8,0,0,1,2.07-4.23,14.56,14.56,0,0,1,2.85-1.77l3.92-1.42s3.21-.79,4.29-1,3.4-.55,4.54-.67c1.56-.16,6.25-.33,6.25-.33a53.7,53.7,0,0,1,5.42,0,9.55,9.55,0,0,1,2.5.67,47,47,0,0,1,3.92,3.92,8,8,0,0,1,.91,1.94,13,13,0,0,1,.09,3.56,23,23,0,0,1-.83,4.5,19.41,19.41,0,0,1-1.92,4,5.54,5.54,0,0,1-2.17,1.67l1.5,1.25,2.5,1.92.92,1.17V437l-3.42,2.75Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Крышка_багажника"
      data-name="Крышка багажника"
    >
      <path
        class="cls-10"
        d="M827.7,455.28l-18,1.08-19.37,1.08-10.85.83h-2.3l-.43-.83L774,451.2s-.56-1.61-.75-1.61h-1.49l-7.06-1.32L757.82,447l-5-1.1-3.19-1.12-2.09-1.61-1.43-2-.93-2.79-.35-3.17-.37-1.76,5.83-.4,12-.78,8.69-.31,14-.47,11.8-.36,14-.15,14.53-.16h9.75l8.38-.1,8.32,0h10.56l10-.13,8.08.15,8.44.16L896,431l1.43.25,2,.25,3.1,1.61,4.91,2.79a19,19,0,0,0,4.22,2c1.24.19,4,.5,5.22.68s8.2,1,8.2,1l7,1.49,4.59,1.49,3.91,2.17,3.29,2.48,1.68,5.15v2l-2-.25-9.93-.62-15.4-.25-16.33-.06-18.26.37-21.73.56-20.86.81Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Фара_задняя"
      data-name="Фара задняя"
    >
      <path
        class="cls-12"
        d="M790.28,492.12l-2.15-.5-9.44-1.37-2.48-.54-1.41-1.49v-2.15l2.07-9.44,1.41-4.64-2.07-12.17-4.23.22-6.87.55-8.28,1-9.61,1.24-4,1.68-1.43.75L738,470.74l-3.53,6.07-3.87,7.8L726,495l-1.66,4.35h6.71l7.2.75h45.12l10.18-.13.5-.61Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Фара_задняя"
      data-name="Фара задняя"
    >
      <path
        class="cls-11"
        d="M939.31,486.16l-3.39,7.2,4.22-.31,6.27-.87,4.49-.82,1-.18,1.18-.93V475.06l-.58-6.62-1-7.7-1.08-4.06-1-.66-3.23-.58-.58-.08v11.26l.66,8.44s.17,4.39.17,4.64-.17,2.73-.17,2.73l-1.16,1.24-2.4,1.16Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="_Бампер_задний-2"
      data-name="Задний бампер"
    >
      <path
        class="cls-13"
        d="M695.65,555.21l3.48,7.45,4,3.06,6.21,3.56,3.73,1.08,4.8.75H723l18.46-1.41,9-.75,2.9-.58,4.8-.5,4.22-.17,3.15-2.57,5.3-4.47,3.81-2.9,3-1.49,2.81-1.08h2.65l11.26-.58,12.34-.41s4.64-.08,4.88,0,1.49.66,1.49.66l1,1.16-.33,1.49-2.48,3-5.55,4-3.48,2.24,5.63-.83,11.09-.91L835,563.57l17.39-1.32,10.27-1.08,11.67-.83L878,560l8.86-.66L890,558.1l3.31-1.49,9.77-.66,7.2-.75,5.84-.56,1.68,1.37,1.24.12,9.62-.68,4-.19,2.17-.31.75-1.06.37-3.35a12.25,12.25,0,0,1,.93-3.42,7.82,7.82,0,0,1,2-2.61,10.64,10.64,0,0,1,3.17-1.12l7.64-1.06,3.85-.5h1.61l.81.68.37,2.73,1.37-1.61,1.68-3,1.12-3.23.31-2.42-.56-2-.31-1.49.19-9.44V509.82l.06-3.29-.68-1.12s-2.55-1.68-3.35-2.17-3.35-3.1-3.35-4.41.19-8.57.19-8.57l-1.18.93-5.46,1-6.27.87-4.22.31-.43.81a18.69,18.69,0,0,1-2.3,3.73,22.93,22.93,0,0,1-3.23,2.73,9.1,9.1,0,0,1-5.22,2c-2.92.12-16,1.06-16,1.06l-28.25,1.92-21.92,1.18-30.67,1.3-16.52.25-5-.31s-4-.56-5.15-1.49a80.42,80.42,0,0,1-6.09-6.15c-.56-.81-2.17-.31-2.17-.31H736.72l-6.27-.43-6.27-.75-1.2,1.85-.79.7L707,502.59l-15.72.82-5.83.27-1.4.22-2.82.45s1.43,2.61,2,4.16,2.86,6.15,4.1,10,3.1,10.31,4.16,13.91,2.67,11.8,3.23,13.6a47,47,0,0,1,.87,6.89Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Крыло_заднее_левое"
      data-name="Крыло заднее"
    >
      <path
        class="cls-14"
        d="M648.21,532.11h-2.73l-2.48-.83-3-.42,1.57-11.58,2.25-15.61,2.15-9.83,2-6.79,4.37-11.46,5.35-11.71,5.86-11.18.37-.87,1.74-1.06,3.73-3,1.74-1.55.68-2.48,5.77-1.53,7.37-2.9,6-2.65,3.15-1.66a11.93,11.93,0,0,0,1.78-1.45,6.5,6.5,0,0,1,.87-1l1.08-2.32,2.36-6.21.62-2.24-.21-2-1.16-1.61-4.26-4.93-6.58-5.71-4.76-3.31-3-1.51,16.25-5.77,4.22,1.7,2.32,1.16-2.48.58-.17.58,6.54,4.06,7.53,5,7,6,6.79,5.88,8.49,8,2.65,2.15,3,1.2,1.45.21.29,1,.43,3.91.93,2.79,1.43,2,1.61,1.43,2.67,1.06,3.91,1,6.77,1.18,8.44,1.68,1.06.56,2.3,4.91,1.49,3.48-.25,1.3-11.74.93-11.05,1.37-5.59.75-4,1.68-1.43.75-1.8,2.48-3.91,6-4,7.7-3.48,7.45L726,495l-1.86,3.91-.75,1.43s-1.06,1-1.24,1.12a8.77,8.77,0,0,1-1.55.25l-18.75,1.24-16.45.75-4.22.68-2.3-3.17-1.61-1.86a20.19,20.19,0,0,0-3-3.66,19.22,19.22,0,0,0-4.22-3.17,16.51,16.51,0,0,0-5.53-2,8.56,8.56,0,0,0-5,.62,14.22,14.22,0,0,0-4.47,2.92,31.74,31.74,0,0,0-4.91,7.82,39.87,39.87,0,0,0-2.92,9.56c-.25,2.42-1.24,7.08-1.18,9s-.06,7.7-.06,7.7l1.24,2.73Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Зеркало_левое"
      data-name="Зеркало"
    >
      <path
        class="cls-15"
        d="M578.25,429.28s-4.1.29-5.75.66a66.46,66.46,0,0,0-7.78,2.32c-.37.33-2.4,1.12-3.15,2.28s-2.11,4.06-2.11,4.06l-.62,3.39a2.9,2.9,0,0,0,0,1.12c.1.16.66.37.66.37l2,1.95,1.95,1.66H565l.41-.37,1.78,0,1.08.08.58.62,2.61,3,2.06,2.08,1.37.45,1.37-.15,2.23-1,1.7-1.66v-.62l-3.39-2.77,1.7-1,.83-1,.87-2.32V439l.33-1.61-.17-3.1a23.31,23.31,0,0,0,.17-3.27,5.28,5.28,0,0,0-1.16-1.53Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Стекло_двери_задней_левой"
      data-name="Стекло задней двери"
    >
      <path
        class="cls-16"
        d="M647.47,399.47l-2.57,4.72L640,411.56l-5,9.52-4.14,8.86-3.56,8.36-2,5.22,12.75-.58,15-.58,10.93-.41,4.8-12.34,2.73-6.54.91-4.22,2.4-9.52,1.16-5.88s-4.39-1.9-4.64-1.9-4.06-.91-4.06-.91l-4.64-1.16-5.3-.5h-6Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Дверь_передняя"
      data-name="Дверь передняя"
    >
      <path
        class="cls-17"
        d="M644,397.12l-3.68.5-4.64.79-5.22,1.32-4.59,1.41-4.18,1.74L617,405.19l-5.3,2.94-5.51,4-3.77,3-3.81,3.31-4.47,4.18-4.72,4.68-6.58,7.33-2.32,2.86-.33,1.61v3.27a9.36,9.36,0,0,1-.87,2.32c-.46.62-.83,1-.83,1l-1.7,1,.62.79,2.77,2v.62s-1.53,1.57-1.7,1.66l-2,1a14.38,14.38,0,0,1-1.61.21l-1.2-.29s-1.41-1.28-1.49-1.41-1.61-1.78-1.61-1.78l-1.7,1.66-2.53,2-2.77,1.82-.91.79-1.28,2.19-2.15,3.93-2.07,4.93-.75,2.48-.75,4.06-.54,4.55v6.25l.41,6.29.21,3.1.58,5,.83,5.14.58,3.1.37,3.77.21,4.26s0,4.51.21,4.8,1.86,4.39,1.86,4.39l2.53,5.8,21.65,5.05,19.75,4.26h.54l-1.12-3.27-2.24-5.34-.83-1.95-.91-2.73.23-1.7.6-2.28.54-3.31s.17-2.48.17-2.61,0-4.06,0-4.06l-.58-4.1-.5-5.26s-.54-5.84-.54-6-.37-6.42-.37-6.42-.08-8.49-.08-8.61.12-4.51.12-4.51l.6-2.61.72-4,1.2-3.73,1-2.61,1.49-3.35,2.11-3.89s1.95-2.77,1.95-2.9a6.93,6.93,0,0,1,.79-1l1.61-1.2,2-1.16,2.36-2,1-1,.79-.66v-1.12s0-.54.21-.62,1-.7,1-.7l.91-.41,2-4.76L624,432.8l3.93-8.44,4.84-8.86,3.39-6,7.37-10.1,1.37-2.48Zm-5.24,4.35s-6.83,10.62-7.14,11.24-6.52,10.8-7.76,13.35-6.71,13-6.71,13l-2.79,5-13.16,1.18-11.05.81-10.12,1,2.36-5.86,2.17-5.51,4.28-4.59,5.4-5.77,6.89-6.33,5.9-4.84,5.59-4,5.46-3.29,6.09-2.73,7.33-2.17,3.85-.93,4.28-.68Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Дверь_задняя_левая"
      data-name="Дверь задняя"
    >
      <path
        class="cls-3"
        d="M674.69,399.6a50.45,50.45,0,0,0-7.64-2.11c-2.17-.25-10.31-1.12-12.36-1.12s-9.79.5-9.79.5l-1.37,2.48-7.37,10.1L628.11,424l-5.27,11.36-3.47,7.94-.26.61-1.57.9-.54.84v1.12L615.65,448l-1.88,1.67-.9.76-2.61,1.62-1,.74-2.4,3.42-1.76,3.12-1.53,3.17-1.43,3.61-1.35,4.15-.72,4-.67,5,0,6.08.16,6.52.47,7,.48,5.22.74,6.44.17,3.3-.13,3.85-.59,4.14-.6,2.75-.23,1.22,1.39,3.87,3.7,9.42,14,2.94,2.17.31,5.65,1.37s5.84,1.24,6.4,1.18,3,0,3,0,.62,0,1.49-1.27a11,11,0,0,0,1.3-3.14s.81-6.71,1-8.51,1.24-9.38,1.24-9.38l1.24-9,1.12-7.95,1.45-8.13,2.53-8.82,2-6.15,2.48-6.09,2.73-6.15,2.61-5.65,3.48-6.83,2.79-5.15.37-.87s1.3-.75,1.74-1.06,3.73-3,3.73-3,1.49-.93,1.74-1.55a16.93,16.93,0,0,0,.68-2.48c.06-.43.31-1.3.31-1.3l.81-1.06.81-5s2-15.62,3.1-20.74c.6-2.72,3.1-10.68,3.1-10.68l.37-1.55.56-.75A58.28,58.28,0,0,0,674.69,399.6Zm.1,9.73-2.4,9.52-.91,4.22-2.73,6.54-4.8,12.34-10.93.41-15,.58-12.75.58,2-5.22,3.56-8.36,4.14-8.86,5-9.52,4.92-7.37,2.57-4.72,3.81-.5h6l5.3.5,4.64,1.16s3.81.91,4.06.91,4.64,1.9,4.64,1.9Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Стекло_двери_передней_левой"
      data-name="Стекло передней двери"
    >
      <path
        class="cls-18"
        d="M584.59,435.61l4.28-4.59,5.4-5.77,6.89-6.33,5.9-4.84,5.59-4,5.46-3.29,6.09-2.73,7.33-2.17,3.85-.93,4.28-.68-.87,1.18s-6.83,10.62-7.14,11.24-6.52,10.8-7.76,13.35-6.71,13-6.71,13l-2.79,5-13.16,1.18-11.05.81-10.12,1,2.36-5.86Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Заднее_стекло"
      data-name="Стекло заднее"
    >
      <path
        class="cls-19"
        d="M738.21,396.31s-15.46,1.06-21.11,1.61-13.41,1.8-13.41,1.8l-2.48.58-.17.58,8.85,5.58,6.8,4.8,10.89,9.39,7.93,7.4,4.56,4,3,1.2,1.45.21h.91s11.74-1,19.44-1.28S796.39,431,801.23,431s25.64-.25,25.64-.25l25.52-.12,20-.12,16.52.31L896,431l1.43.25s-7.08-4.72-8.07-5.22-16.08-9.56-19.31-10.87S855.32,408,855.32,408s-8.32-4.1-11.92-5-5.88-1.65-10.87-2.86a129.39,129.39,0,0,0-19.87-2.61c-6.2-.45-14.1-1.49-24.34-1.68s-20.68-.25-28.75-.25C754.22,395.63,738.21,396.31,738.21,396.31Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="Крыло_переднее_левое"
      data-name="Крыло переднее"
    >
      <path
        class="cls-4"
        d="M550.19,527.88h2L559,529l4,.75-3.86-9-.53-1.21-.2-4.47-.18-4.05-.66-5.68-1.26-7.83-.7-7.52-.39-7.11v-5.55l.68-4.82,1.53-6.2,1.89-4.5,2.93-5.27.5-.86,3.24-2.32,2.43-1.86,2.23-2.08-2.32-2.65-2.86-.12-.41.37h-1.61l-1.41.5s-5.63,2.15-8.28,3.23-9,3.31-11.92,4.72a38.32,38.32,0,0,0-7.78,4.88c-2.57,2.07-4,5.22-4.8,6.37a16.42,16.42,0,0,0-4.22,7.95c-.21.85,1.41,3.23,1.41,3.23,1.9-4.14,5.46-2.9,5.46-2.9l3.15,2.4,2.15,2.9a22.12,22.12,0,0,1,2.48,4.88c.91,2.65,2.9,8.36,2.9,8.36l3.6,14.41,2.77,14.07Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
    <g
      id="крыша-2"
      data-name="Крыша"
    >
      <path
        class="cls-19"
        d="M701.92,399.54s-4.83-2.42-6.25-3-6.21-2.29-11.33-3.92a71.51,71.51,0,0,0-10.75-1.79c-2.5-.12-15.29-.33-15.29-.33l15.5-1.42s11.54-.62,14.58-.87,13.79-.58,15.38-.67,18-.21,21.54-.21,20,.38,22.33.38,7.25.29,7.25.29a7,7,0,0,1,1.79-2,7.7,7.7,0,0,1,2.71-1.33,28.56,28.56,0,0,1,5.13,0,6.48,6.48,0,0,1,2.13.33,10.23,10.23,0,0,1,1.67,2.17c.25.54.79,1.79.79,1.79l10.67.92s14.75,1.71,17.67,2.21,13.25,1.5,13.25,1.5,4.87.94,6.5,1.17c3.83.54,10.21,2.29,12.21,2.79s11.38,3.63,11.75,3.75,2.67,1.08,2.67,1.08-14.83-2.83-19.37-3.67-15.17-1.5-19.67-1.87-20.37-1.25-22.75-1.12-17.42,0-20.21.13-19.16.29-22.5.46-23.71,1.92-23.71,1.92-12.75,1.5-13.17,1.71Z"
        transform="translate(-22.72 -336.94)"
      ></path>
    </g>
  </svg>
</template>

<style scoped>
svg path {
  opacity: 0;
  cursor: pointer;
}

svg path:hover {
  fill: #df192c;
  fill-opacity: 0.6;
  opacity: 0.5;
}

.active_part path {
  fill: #ad1323;
  fill-opacity: 1 !important;
  opacity: 0.7;
}

.selected_part path {
  fill: #df192c;
  fill-opacity: 0.85 !important;
  opacity: 0.45;
}
</style>